/*!
 * Solva — Sticky mobile ATC
 * Reveals the .solva-stickybar once the user has scrolled past the PDP
 * (so it doesn't compete with the visible inline CTA), hides it again
 * once the final-cta or footer enters the viewport.
 */
(function () {
  if (typeof window === 'undefined') return;
  if (window.matchMedia && !window.matchMedia('(max-width: 900px)').matches) return;

  var bar = document.querySelector('[data-solva-stickybar]');
  if (!bar) return;

  var pdp = document.querySelector('.solva-pdpx');
  if (!pdp) return;

  // Hide if any of these are in viewport (avoid double-CTA noise)
  var hideOn = document.querySelectorAll('.solva-final, .solva-pa, footer');

  var lastVisible = null;
  function update() {
    var pdpRect = pdp.getBoundingClientRect();
    var scrolledPastPdp = pdpRect.bottom < window.innerHeight * 0.5;

    var anyHideInView = false;
    for (var i = 0; i < hideOn.length; i++) {
      var r = hideOn[i].getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        anyHideInView = true;
        break;
      }
    }

    var shouldShow = scrolledPastPdp && !anyHideInView;
    if (shouldShow !== lastVisible) {
      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      lastVisible = shouldShow;
    }
  }

  var ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () { update(); ticking = false; });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();
